<div class="kt-card max-w-[440px] w-full mx-auto">
  <div class="kt-card-content p-10">
    <div class="flex justify-center py-10">
      <img alt="image" class="dark:hidden max-h-[130px]" src="/assets/media/illustrations/30.svg"/>
      <img alt="image" class="light:hidden max-h-[130px]" src="/assets/media/illustrations/30-dark.svg"/>
    </div>
    <h3 class="text-lg font-medium text-mono text-center mb-3">Check your email</h3>
    <div class="text-sm text-center text-secondary-foreground mb-7.5">
      @if (type === 'signup') {
        Please click the link sent to 
        <span class="text-mono font-medium text-primary">{{ email || 'your email' }}</span>
        to verify your account. Thank you
      } @else {
        Please click the link sent to your email to reset your password. Thank you
      }
    </div>
    <div class="flex justify-center mb-5">
      <a class="kt-btn kt-btn-primary flex justify-center" routerLink="/auth/sign-in">Back to Sign In</a>
    </div>
    <div class="flex items-center justify-center gap-1">
      <span class="text-xs text-secondary-foreground">Didn't receive an email?</span>
      @if (resendStatus === 'sending') {
        <span class="text-xs font-medium text-secondary-foreground">Sending...</span>
      } @else if (resendStatus === 'sent' && cooldown > 0) {
        <span class="text-xs font-medium text-green-500">Sent! Resend in {{ cooldown }}s</span>
      } @else if (resendStatus === 'error') {
        <button class="text-xs font-medium link" (click)="resend()">Failed. Try again</button>
      } @else {
        <button class="text-xs font-medium link" (click)="resend()">Resend</button>
      }
    </div>
  </div>
</div>
